import './style.css';

const forms = document.querySelectorAll<HTMLFormElement>('[data-waitlist-form]');

forms.forEach((form) => {
  const status = form.querySelector<HTMLElement>('.form-status');
  const submit = form.querySelector<HTMLButtonElement>('button[type="submit"]');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!form.reportValidity() || !status || !submit) return;

    const data = new FormData(form);
    const email = String(data.get('email') ?? '').trim();
    const company = String(data.get('company') ?? '');

    submit.disabled = true;
    status.className = 'form-status';
    status.textContent = 'Joining the list…';

    try {
      const response = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email, company }),
      });
      const body = await response.json() as { message?: string };
      if (!response.ok) throw new Error(body.message || 'Something went wrong. Please try again.');

      status.classList.add('is-success');
      status.textContent = body.message || 'Check your inbox to confirm your place.';
      form.reset();
    } catch (error) {
      status.classList.add('is-error');
      status.textContent = error instanceof Error ? error.message : 'Something went wrong. Please try again.';
    } finally {
      submit.disabled = false;
    }
  });
});

const year = document.querySelector<HTMLElement>('#current-year');
if (year) year.textContent = String(new Date().getFullYear());
